export default __webpack_public_path__ + "static/media/chatClose.32b4d1d0.svg";